import { render, staticRenderFns } from "./arrearsPay.vue?vue&type=template&id=630f74a1&scoped=true&"
import script from "./arrearsPay.vue?vue&type=script&lang=js&"
export * from "./arrearsPay.vue?vue&type=script&lang=js&"
import style0 from "./arrearsPay.vue?vue&type=style&index=0&id=630f74a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f74a1",
  null
  
)

export default component.exports